import React from 'react'
import {
    Line, Bar, Pie, Text, Gauge, Treemap, Radar, MultiText, LMX,
} from 'frontend-charts'
import TextResponseChart from '../charts/TextResponseChart'

const chartPropResets = [
    {
        path: ['yAxis', 'axisLabel', 'show'],
        value: false,
    },
    {
        path: ['yAxis', 'splitLine', 'show'],
        value: false,
    },
    {
        path: ['xAxis', 'axisLabel', 'show'],
        value: false,
    },
    {
        path: ['xAxis', 'show'],
        value: false,
    },
    {
        path: ['tooltip', 'show'],
        value: false,
    },
]

const chartIcons = [
    {
        chart: <Bar
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
            ]}
            benchmarkData={[
                {
                    name: 'series B',
                    data: [
                        3,
                        3,
                        1,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={chartPropResets}
        />,
        title: 'Grouped column chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'groupedColumn',
        defaultSize: 8,
    },
    {
        chart: <Bar
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={chartPropResets}
        />,
        title: 'Column chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'column',
        defaultSize: 8,
    },
    {
        chart: <Bar
            xAxisLabels={['label one', 'label two', 'label three']}
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
                {
                    name: 'series B',
                    data: [
                        3,
                        1,
                        1,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={chartPropResets}
        />,
        title: 'Stacked bar chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'stackedColumn',
        defaultSize: 8,
    },
    {
        chart: <Bar
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={[
                {
                    path: ['xAxis', 'axisLabel', 'show'],
                    value: false,
                },
                {
                    path: ['xAxis', 'splitLine', 'show'],
                    value: false,
                },
                {
                    path: ['yAxis', 'axisLabel', 'show'],
                    value: false,
                },
                {
                    path: ['yAxis', 'show'],
                    value: false,
                },
                {
                    path: ['tooltip', 'show'],
                    value: false,
                },
            ]}
            transpose
        />,
        title: 'Bar chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'bar',
        defaultSize: 4,
    },
    {
        chart: <Bar
            xAxisLabels={['label one', 'label two', 'label three']}
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
                {
                    name: 'series B',
                    data: [
                        3,
                        1,
                        1,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={[
                {
                    path: ['xAxis', 'axisLabel', 'show'],
                    value: false,
                },
                {
                    path: ['xAxis', 'splitLine', 'show'],
                    value: false,
                },
                {
                    path: ['yAxis', 'axisLabel', 'show'],
                    value: false,
                },
                {
                    path: ['yAxis', 'show'],
                    value: false,
                },
                {
                    path: ['tooltip', 'show'],
                    value: false,
                },
            ]}
            transpose
        />,
        title: 'Stacked bar chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'stackedBar',
        defaultSize: 4,
    },
    {
        chart: <Pie
            chartData={[
                {
                    value: 20,
                    name: 'series 1',
                },
                {
                    value: 30,
                    name: 'series 2',
                },
                {
                    value: 10,
                    name: 'series 3',
                },
                {
                    value: 40,
                    name: 'series 4',
                },
                {
                    value: 30,
                    name: 'series 5',
                },
                {
                    value: 60,
                    name: 'series 6',
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={[
                {
                    path: ['legend', 'show'],
                    value: false,
                },
                {
                    path: ['tooltip', 'show'],
                    value: false,
                },
            ]}
            compact
        />,
        title: 'Pie chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'pie',
        defaultSize: 2,
    },
    {
        chart: <Pie
            chartData={[
                {
                    value: 20,
                    name: 'series 1',
                },
                {
                    value: 30,
                    name: 'series 2',
                },
                {
                    value: 10,
                    name: 'series 3',
                },
                {
                    value: 40,
                    name: 'series 4',
                },
                {
                    value: 30,
                    name: 'series 5',
                },
                {
                    value: 60,
                    name: 'series 6',
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={[
                {
                    path: ['legend', 'show'],
                    value: false,
                },
                {
                    path: ['tooltip', 'show'],
                    value: false,
                },
            ]}
            compact
            donut
        />,
        title: 'Donut chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'donut',
        defaultSize: 2,
    },
    {
        chart: <Treemap
            chartData={[
                {
                    value: 20,
                    name: 'series 1',
                },
                {
                    value: 30,
                    name: 'series 2',
                },
                {
                    value: 10,
                    name: 'series 3',
                },
                {
                    value: 40,
                    name: 'series 4',
                },
                {
                    value: 30,
                    name: 'series 5',
                },
                {
                    value: 60,
                    name: 'series 6',
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={[
                {
                    path: ['legend', 'show'],
                    value: false,
                },
                {
                    path: ['tooltip', 'show'],
                    value: false,
                },
            ]}
            compact
            donut
        />,
        title: 'Treemap chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'treemap',
        defaultSize: 4,
    },
    {
        chart: <Radar
            chartData={[
                {
                    name: 'series A',
                    data: [
                        1,
                        2,
                        3,
                    ],
                },
            ]}
            indicators={[{ name: 'series A' }]}
            style={{ height: '100px', width: '60px' }}
        />,
        title: 'Radar chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'radar',
        defaultSize: 8,
    },
    {
        chart: <Text
            mainText="$1000.50"
            subText="Company net sales"
            style={{ height: '100px', width: '60px' }}
        />,
        title: 'Text chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'text',
        defaultSize: 2,
    },
    {
        chart: <Line
            chartData={[
                {
                    name: 'series A',
                    data: [
                        0,
                        1,
                        2,
                        3,
                    ],
                },
            ]}
            benchmarkData={[
                {
                    name: 'series B',
                    data: [
                        1,
                        2,
                        3,
                        4,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={chartPropResets}
        />,
        title: 'Line chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'line',
        defaultSize: 8,
    },
    {
        chart: <Line
            xAxisLabels={['label one', 'label two', 'label three']}
            chartData={[
                {
                    name: 'series A',
                    data: [
                        0,
                        1,
                        2,
                        3,
                    ],
                },
                {
                    name: 'series B',
                    data: [
                        1,
                        4,
                        3,
                        4,
                    ],
                },
            ]}
            style={{ height: '100px', width: '60px' }}
            layoutEdit={chartPropResets}
            type="stack"
        />,
        title: 'Stacked line chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'stackedLine',
        defaultSize: 8,
    },
    {
        chart: <Gauge
            chartData={45}
            style={{ height: '100px', width: '60px' }}
            containerSize={{ height: 190, width: 190 }}
            layoutEdit={[
                {
                    path: ['series', 0, 'pointer', 'width'],
                    value: 3,
                },
                {
                    path: ['series', 0, 'pointer', 'length'],
                    value: '52%',
                },
                {
                    path: ['series', 0, 'pointer', 'offsetCenter'],
                    value: [0, '-7%'],
                },
                {
                    path: ['series', 0, 'axisTick', 'distance'],
                    value: -15,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'fontSize'],
                    value: 25,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'lineHeight'],
                    value: 25,
                },
                {
                    path: ['series', 0, 'detail', 'show'],
                    value: false,
                },
                {
                    path: ['series', 0, 'axisLabel', 'show'],
                    value: false,
                },
                {
                    path: ['series', 0, 'splitLine', 'show'],
                    value: false,
                },
                {
                    path: ['series', 0, 'startAngle'],
                    value: 180,
                },
                {
                    path: ['series', 0, 'endAngle'],
                    value: 0,
                },
            ]}
        />,
        title: 'Gauge chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'gauge',
        defaultSize: 2,
    },
    {
        chart: <Gauge
            chartData={4}
            style={{ height: '100px', width: '60px' }}
            containerSize={{ height: 190, width: 190 }}
            layoutEdit={[
                {
                    path: ['series', 0, 'pointer', 'width'],
                    value: 15,
                },
                {
                    path: ['series', 0, 'axisTick', 'distance'],
                    value: -15,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'fontSize'],
                    value: 12,
                },
                {
                    path: ['series', 0, 'detail', 'rich', 'a', 'lineHeight'],
                    value: 25,
                },
                {
                    path: ['series', 0, 'detail', 'offsetCenter'],
                    value: [0, '35%'],
                },
            ]}
        />,
        title: '0 to 5 Gauge chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'gauge0-5',
        defaultSize: 2,
    },
    {
        chart: <MultiText
            chartData={[
                <div style={{ fontSize: '12px' }}>Data One</div>,
                <div style={{ fontSize: '12px' }}>Data Two</div>,
                <div style={{ fontSize: '12px' }}>Data Three</div>,
                <div style={{ fontSize: '12px' }}>Data Four</div>,
            ]}
            style={{ height: '100px', width: '60px' }}
            containerSize={{ height: 190, width: 190 }}
        />,
        title: 'Multi Text Chart',
        description: 'The bar graph helps to compare the different sets of data among different groups easily.',
        key: 'multiText',
        defaultSize: 2,
    },
    {
        chart: (
            <div className="quadrantAnalysisContainer">
                <div className="quadrantAnalysis" style={{ width: '60px' }}>
                    <div className="tl" style={{ width: '29px', height: '16px' }}><div className="ss" /></div>
                    <div className="tr" style={{ width: '29px', height: '16px' }}><div className="ss" /></div>
                    <div className="bl bottom" style={{ width: '29px', height: '16px' }}><div className="ss" /></div>
                    <div className="br bottom" style={{ width: '29px', height: '16px' }}><div className="ss" /></div>
                </div>
            </div>
        ),
        title: 'Quadrant Analysis',
        description: 'A scatter chart showing your key metrics',
        key: 'quadrantAnalysis',
        defaultSize: 8,
    },
    {
        chart: (
            <LMX
                chartData={[
                    { name: '', value: '' },
                    { name: '', value: '' },
                    { name: '', value: '' },
                    { name: '', value: '' },
                ]}
                style={{ height: '40px', width: '60px' }}
            />
        ),
        title: 'Loyalty and satisfaction',
        description: 'A chart showing the loyalty vs satisfaction of respondents',
        key: 'lmx',
        defaultSize: 8,
    },
    {
        chart: (
            <div style={{ padding: '0 4px' }}>
                <div style={{ marginTop: '-4px' }}>.........</div>
                <div style={{ display: 'flex' }}>
                    <i className="fa-solid fa-quote-left" style={{ color: '#16CCC1', fontSize: '5px' }} />
                    <div style={{ fontSize: '5px' }}>............</div>
                </div>
                <div style={{ display: 'flex' }}>
                    <i className="fa-solid fa-quote-left" style={{ color: '#16CCC1', fontSize: '5px' }} />
                    <div style={{ fontSize: '5px' }}>............</div>
                </div>
                <div style={{ display: 'flex' }}>
                    <i className="fa-solid fa-quote-left" style={{ color: '#16CCC1', fontSize: '5px' }} />
                    <div style={{ fontSize: '5px' }}>............</div>
                </div>
            </div>
        ),
        key: 'textResponse',
        defaultSize: 2,
    },
    {
        chart: (
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: '#16CCC1',
                }}
            >
                <i className="fa-solid fa-cloud" />
            </div>
        ),
        key: 'wordCloud',
        defaultSize: 2,
    },
]

export default chartIcons
